<span class="session-id">{{sessionId$ | async}}</span>
